/**
 * Key used in `liveDropInfo.liveSlugs`.
 *
 * A drop page slug can be shared by several drop configs (e.g. an Editions
 * release and a Primary release of the same collection), each with its own
 * checkout window. Suffixing the slug with the platform keeps their live
 * status independent, so a closed Editions drop is not reported live because
 * the Primary drop on the same slug is still open.
 */
export const getLiveSlug = (slug: string, platform: string): string =>
	`${slug}-${platform}`;
